<template>
  <div>
    <van-dialog v-model="dialogFormVisible" title="修改名称" show-cancel-button :beforeClose="handleClose">
        <van-field v-model="dname" placeholder="请输入设备名称" />
    </van-dialog>
  </div>
</template>

<script>
  export default {
    name: 'DevName',
    props: [
      "did"
    ],
    data() {
      return {
        dialogFormVisible: true,
        dname: '',
      };
    },
    methods: {
      handleClose(action, done) {
        if (action === 'confirm') {
          done(false);
          this.rename(this.did, this.dname);
        } else if (action === 'cancel') {
          this.$emit('configstatus', false);
          done(); //关闭
        }
      },
      rename(did, udname) {
        const qs = require('qs');
        this.$axios.post('/api/dev/udname', qs.stringify({ 'did': did, 'udname': udname }))
          .then((response) => {
            if (response.data.error_code === 0) {
              this.$emit('configstatus', true);
            }
            else if (response.data.error_code === 301) {
              this.$router.push({ path: '/login', name: 'login' })
            }

          })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import "../../assets/hkapp.css";
</style>